import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { logger } from '~/features/logging/logger';
import { getUserIdFromJwt } from '~/features/user/utils/get-user-id-from-jwt';
import { queryUdacityService } from '~/utils/query-udacity-service';

import {
  EnrollmentProgressRaw,
  enrollmentProgressRawSchema,
  fetchEnrollmentProgressQuery,
} from '../models/enrollment-progress';

export async function getEnrollmentProgressRaw(programKey: string): Promise<EnrollmentProgressRaw> {
  const jwt = auth.getJWT();

  if (!jwt) {
    logger.fatal('Missing JWT', {
      file: 'src/features/program/controllers/get-enrollment-progress-raw.ts',
      function: 'getEnrollmentProgressRaw',
    });

    throw new Error('Missing JWT');
  }

  const userId = getUserIdFromJwt(jwt);

  if (!userId) {
    logger.fatal('Provided JWT does not contain a user ID', {
      file: 'src/features/program/controllers/get-enrollment-progress-raw.ts',
      function: 'getEnrollmentProgressRaw',
    });

    throw new Error('Provided JWT does not contain a user ID');
  }

  return await queryUdacityService({
    url: publicEnv.NEXT_PUBLIC_PROGRESS_URL,
    zodSchema: enrollmentProgressRawSchema,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      query: fetchEnrollmentProgressQuery,
      variables: { uid: userId, key: programKey },
    }),
  });
}
